module.exports = __webpack_public_path__ + "static/img/bauxite_256.eaf705e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bauxite_256.png
// module id = xM7n
// module chunks = 0